import { Box, GlobalStyles } from '@mui/material';
import { Outlet } from 'react-router-v7';
import Navbar from './Navbar';

export const MainLayout = () => {
	return (
		<>
			<GlobalStyles
				styles={(theme) => ({ ':root': { '--status-bar-background': theme.palette.secondary.main } })}
			/>
			<Navbar />
			<Box p={2}>
				<Outlet />
			</Box>
		</>
	);
};
